const productTypeName = {
  BIGPACKFAST: "BIGPACK FAST",
  INTERPACKMAXI: "INTERPACK MAXI"
} as any;

const mapProductTypeName = (productName = "") => {
  return productTypeName[productName.toUpperCase()] || productName;
};

export default mapProductTypeName;
